<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker placeholder="Select Date" v-model="searchDate" format="DD-MMM-YYYY" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Kategori</label>
                  <a-select placeholder="Ex: Avionik ... " v-model="kategori" class="width-full" initialValue="proyek"
                    allowClear>
                    <a-select-option v-for="item in getSupplierType" :key="item.id" :value="item.value">{{ item.label
                    }}</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option v-for="item in getStatus" :key="item.id" :value="item.value">{{ item.label
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="Supplier List" :manifestLink="getManifestLink" :dataList="searching"
        :rating="true" :disabledCreateEditLink="true" />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "axios";
import moment from "moment";

export default {
  name: "Supplier",
  props: ["prnMenu"],
  data() {
    return {
      loading: true,
      purchasingList: [],
      search: "",
      searchDate: null,
      status: undefined,
      kategori: undefined,
      pagination: {
        pageSize: 5,
        size: "small",
      },
    };
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getSupplierType", "getStatus"]),
    searching() {
      let output = this.purchasingList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        output = output.filter(
          (obj) =>
            obj.kategori &&
            obj.kategori.toLowerCase().indexOf(this.kategori.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let searchDate = moment(this.searchDate).format("YYYY-MM-DD");
        output = output.filter((obj) => obj.tanggal === searchDate);
      }

      return output;
    },
    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/direktur") {
        return "SpclSupplierManifestDir";
      } else if (localStorage.getItem("nvpn") === "/ga") {
        return "SpclSupplierManifestGA";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclSupplierManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclSupplierManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclSupplierManifestFin";
      } else {
        return "SpclSupplierManifest_";
      }
    },
  },
  methods: {
    fetchPurchasing() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "suplier",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          response.data.data.forEach((data) => {
            this.purchasingList.push({
              title: data.nama_perusahaan,
              subdesc: [data.nama_pembuat, data.jenis_produk],
              status: data.status,
              id: data.id_supplier,
              rating_value: data.nilai_evaluasi,
              kategori: data.kategori,
              tanggal: data.tanggal,
              searchQ:
                data.nama_perusahaan +
                " " +
                data.nama_pembuat +
                " " +
                data.jenis_produk,
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
  mounted() {
    this.fetchPurchasing();
  },
};
</script>

<style></style>